<app-peform-inspection-form
  [disabled]="false"
  [input]="record$ | async"
  (formUpdated)="saveRecord($event)">
</app-peform-inspection-form>
